'use client';

import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { useCheckboxController } from '../../../../hooks/form-controllers';
import { ReactNode, useEffect } from 'react';
import { Conditional } from '../../../common';
import { useFormContext } from 'react-hook-form';
import styles from '../../AssociatedDealer.module.scss';
import cx from 'classnames';

interface Props {
  name: string;
  label: string;
  fieldNote: ReactNode;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  showCheckbox?: boolean;
  className?: string;
}

export const AssociatedDealerCheckbox = ({
  name,
  label,
  fieldNote,
  checked = false,
  required = false,
  disabled = false,
  showCheckbox = true,
  className = ''
}: Props) => {
  const { checkboxFieldset, booleanCheckboxField } = useCheckboxController({
    name
  });
  const { setValue, resetField } = useFormContext();

  useEffect(() => {
    if (checked) {
      setValue(name, checked);
    }
    return () => {
      resetField(name);
    };
  }, [checked]);

  return (
    <Conditional test={showCheckbox}>
      <div className={className}>
        <CatFieldset className="u-color--ExtraDarkGray" {...checkboxFieldset}>
          <CatCheckboxField
            {...booleanCheckboxField}
            required={required}
            disabled={disabled}
          >
            <div
              className={cx(
                styles['padding-center'],
                'cat-u-theme-typography-label'
              )}
            >
              {label}
              <Conditional test={required}>
                <span className={styles['required-field']}>
                  {' (required)'}
                </span>
              </Conditional>
            </div>
          </CatCheckboxField>
          <Conditional test={!!fieldNote}>
            <span slot="field-note" className="mt-1">
              {fieldNote}
            </span>
          </Conditional>
        </CatFieldset>
      </div>
    </Conditional>
  );
};
